import React from 'react'
import '../Assets/Css/webfooter.css'
import { Col, Container, Row } from 'react-bootstrap'
import { FaLocationDot } from "react-icons/fa6";
import { FaMobileAlt } from "react-icons/fa";
import { MdEmail } from "react-icons/md";
import { FaFacebookF } from "react-icons/fa6";
import { IoLogoYoutube } from "react-icons/io";
import { FaInstagram } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";



export default function WebFooter() {


  return (
    <>

      <Col lg={12}>
        <div className='p-1 ' style={{ backgroundColor: '#14234C' }}>
          <Container>
            <Row className='mt-3'>
              <Col lg={4}>
                <h5 style={{ color: '#D9CB80' }}> AIM Industrial Products </h5>
                <p className='text-white' >
                  We’re always looking to connect with those who share an interest
                  in a sustainable future.
                </p>

                <div className='d-flex '>

                  <a className='iconback' href="https://www.facebook.com/share/1FG6dqFDEw/">
                    <FaFacebookF />
                  </a>


                  <a className='iconback mx-2' href='https://www.youtube.com/@AimIndustrialProducts'>
                    <IoLogoYoutube />
                  </a>
                  <a className='iconback mx-1' href='https://www.instagram.com/aimindustrialproducts?igsh=Ym81aGlxdWgyNmx0'>
                    <FaInstagram />
                  </a>
                  <a className='iconback mx-1' href='https://x.com/aimindproducts'>
                    <FaXTwitter />
                  </a>
                </div>

              </Col>

             <Col lg={2}>
  <h5 style={{ color: '#D9CB80' }}>Quick Links</h5>
  <ul className="custom-list">
    <li>
      <a href="/aboutus" className="text-white" style={{ textDecoration: 'none' }}>
        About Us
      </a>
    </li>
    <li>
      <a href="/products" className="text-white" style={{ textDecoration: 'none' }}>
        Products
      </a>
    </li>
    <li>
      <a href="/blog" className="text-white" style={{ textDecoration: 'none' }}>
        Blogs
      </a>
    </li>
    <li>
      <a href="/faqs" className="text-white" style={{ textDecoration: 'none' }}>
        FAQs
      </a>
    </li>
  </ul>
</Col>



              <Col lg={3}>
                <h5 style={{ color: '#D9CB80' }}>Contact</h5>
                <div className='mb-2 '>
                  <a
                    href="https://wa.me/9822980560 "
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ textDecoration: 'none', color: 'inherit' }}
                  >
                    <span className='text-white'>

                      <FaMobileAlt color='white' />  +91 9822980560

                    </span>
                  </a>
                </div>

                <div className='mb-2 '>
                  <a
                    href="https://wa.me/9822980225
 "
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ textDecoration: 'none', color: 'inherit' }}
                  >
                    <span className='text-white'>

                      <FaMobileAlt color='white' />  +919822980225


                    </span>
                  </a>
                </div>

                <div className='d-flex '>
                  <a
                    href="mailto:info@aimindproducts.com"
                    style={{ textDecoration: 'none', color: 'inherit', display: 'inline-flex', alignItems: 'center', gap: '6px' }}
                  >
                    <span className='text-white'>
                      < MdEmail color='white'/>  info@aimindproducts.com
                    </span>
                  </a>

                </div>

              </Col>
              <Col lg={3}  >
                <h5 style={{ color: '#D9CB80' }}> Office</h5>
                <div className='d-flex'>
                  <span><FaLocationDot color='white' /></span>
                  <a
                    href='https://maps.app.goo.gl/a6EoofWWzXSf2dmX7'
                    target='_blank'
                    rel='noopener noreferrer'
                    className='text-white ms-2 text-decoration-none'
                  >
                    :- C 306,Sahyadri Shruberry, Shiv Rasta, Pimpri Chinchwad, Pune, Pimpri Chinchwad-412105, Maharashtra, India
                  </a>
                </div>


                <h5 style={{ color: '#D9CB80' }}> Factory</h5>
                <div className='d-flex '>
                  <span><FaLocationDot color='white' /></span>
                  <a
                    href='https://maps.app.goo.gl/9xKo6n51gEMhnmue7'
                    target='_blank'
                    rel='noopener noreferrer'
                    className='text-white ms-2 text-decoration-none'
                  >

                    :- Shop no 11 behind mayuresh hotel ,shantinagar,bhosari, Pimpri Chinchwad pune 411026
                  </a>
                </div>

              </Col>
            </Row>

            <div className='text-white mt-3 footerend text-center'>
              <hr />
              <p>© {new Date().getFullYear()} AIM Industrial Products |
                <a href="https://www.bighostindia.in/" style={{ color: 'white', textDecoration: 'none' }}>Design By : BigHost India Private Limited</a> </p>
            </div>
          </Container>
        </div>
      </Col>


    </>
  )
}
